import { render, staticRenderFns } from "./StatisticsSection.vue?vue&type=template&id=20f6b334&"
import script from "./StatisticsSection.vue?vue&type=script&lang=js&"
export * from "./StatisticsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports